import axios from 'axios';

// Map common MIME types to extensions (replaces Node-only mime-types package)
const MIME_TO_EXT = {
  'application/pdf': 'pdf',
  'image/jpeg': 'jpg',
  'image/png': 'png',
  'image/gif': 'gif',
  'image/webp': 'webp',
  'image/svg+xml': 'svg',
  'text/plain': 'txt',
  'text/html': 'html',
  'text/css': 'css',
  'application/json': 'json',
  'application/zip': 'zip',
};

const hasExtension = (name) => /\.\w{2,}$/.test(name);

const downloadByUrl = async (urlSrc, filename) => {
  try {
    const response = await axios({
      method: 'GET',
      url: urlSrc,
      responseType: 'blob',
      headers: { Accept: '*/*' },
    });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    let fileName = filename;

    if (!hasExtension(fileName)) {
      const ext = MIME_TO_EXT[response.data.type];
      if (ext) fileName = `${fileName}.${ext}`;
    }

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();

    window.URL.revokeObjectURL(url);
  } catch (e) {
    console.log('Error:', e);
  }
};

export default downloadByUrl;
